import { Switch } from "@headlessui/react"
import { getPrice } from "@lib/swell/storefront-data-hooks/src/utils/product"
import Image from "next/legacy/image"

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ")
}

export interface ToggleWithImageProps {
  options?: Readonly<Array<string | undefined>>
  onChange: any
  selected: boolean
  option: any
}

const ToggleWithImage: React.FC<ToggleWithImageProps> = ({ onChange, selected, option }) => {
  const { name, description } = option
  const optionValue = option.values[0]

  return (
    <div className="flex flex-col">
      <div className="relative h-24">
        <Image
          quality="85"
          src={option.option_value_image.url}
          alt={option.name}
          loading="eager"
          objectFit="cover"
        />
      </div>

      <div className="mt-4">
        <Switch.Group as="div" className="flex flex-col justify-between space-y-4">
          <span className="flex grow flex-col space-y-2">
            <Switch.Label as="span" className="text-sm font-medium text-gray-900" passive>
              {name}
            </Switch.Label>

            <Switch.Description as="span" className="text-sm text-gray-500">
              {description}
            </Switch.Description>
          </span>
          {/* @ts-ignore */}
          <span className="flex">
            <Switch
              checked={selected}
              onChange={onChange}
              className={classNames(
                selected ? "bg-primary-600" : "bg-gray-200",
                "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              )}
            >
              <span
                aria-hidden="true"
                className={classNames(
                  selected ? "translate-x-5" : "translate-x-0",
                  "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out"
                )}
              />
            </Switch>
            <div className="grow" />
            <span className="text-xs text-gray-500">
              {optionValue.price ? ` ${getPrice(optionValue.price, "usd")}` : <></>}
            </span>
          </span>
        </Switch.Group>
      </div>
    </div>
  )
}

export default ToggleWithImage
